import type { ComponentProps } from 'react'
import { useCallback } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children' | 'onClick'> {
  checkIn?: string
  firstAvailableDuration?: number
  shouldSkipDurationStep?: boolean
}

function MultiRoomSelectRoomsCtaButton(props: Props) {
  const {
    checkIn,
    firstAvailableDuration,
    shouldSkipDurationStep,
    ...textButtonProps
  } = props

  const intl = useIntl()
  const offerPageDispatch = useOfferPageDispatch()

  const onSelectRoomsClick = useCallback(() => {
    offerPageDispatch({ type: OfferPageActions.toggleMultiRoomSelectRooms, isMultiRoomSelectRooms: true })

    if (!checkIn) {
      if (shouldSkipDurationStep && firstAvailableDuration != null) {
        offerPageDispatch({ type: OfferPageActions.setDuration, duration: firstAvailableDuration })
        offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
      } else {
        offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'duration' })
      }

      return
    }

    offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'multiRoomSelect' })
  }, [checkIn, firstAvailableDuration, offerPageDispatch, shouldSkipDurationStep])

  const selectRoomsButtonText = checkIn
    ? intl.formatMessage({
        id: 'wmNYORSXAGnJQoYClMiH',
        defaultMessage: 'Select rooms',
      })
    : intl.formatMessage({
        id: 'f6ucrlxn3Ej_isWo_JDQ',
        defaultMessage: 'Check availability',
      })

  return (
    <TextButton
      {...textButtonProps}
      kind="primary"
      onClick={onSelectRoomsClick}
    >
      {selectRoomsButtonText}
    </TextButton>
  )
}

export default MultiRoomSelectRoomsCtaButton
